import React from 'react';
import { localAnalytics } from '../../utils/analytics';

interface AndroidDownloadButtonProps {
  userId: string | null;
  additionalData?: Record<string, any>;
  source?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

export const AndroidDownloadButton: React.FC<AndroidDownloadButtonProps> = ({
  userId,
  additionalData = {},
  source = 'unknown',
  style,
  onClick,
}) => {
  const handleClick = () => {
    localAnalytics().logEvent('AndroidDownloadClicked', {
      screen: 'PaywallModal',
      action: 'AndroidDownloadClicked',
      userId,
      platform: 'android',
      source,
      ...additionalData,
    });

    if ((window as any).generateBranchLink) {
      (window as any).generateBranchLink(
        'android',
        additionalData.bookTitle || null,
        additionalData.chapterNumber || null
      );
    } else {
      const url =
        'https://play.google.com/store/apps/details?id=com.paradoxbuilders.nanoreads&hl=en_GB';
      window.open(url, '_blank');
    }

    onClick?.();
  };

  const buttonStyle: React.CSSProperties = {
    width: 160,
    height: 46,
    cursor: 'pointer',
    border: 'none',
    background: 'transparent',
    padding: 0,
    ...style,
  };

  const imageStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  };

  return (
    <button style={buttonStyle} onClick={handleClick}>
      <img
        src="/img/books/android_button.png"
        alt="Download on Google Play"
        style={imageStyle}
      />
    </button>
  );
};
